export default "__VITE_ASSET__DERR7Rag__"